import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Box, Circle } from 'rebass';

import { Paragraph } from 'shared-components';

import { GlowHeading } from 'components';

import { T } from 'containers';
import { AppText } from 'domain/appText';

const StyledCircle = styled(Circle)`
  border: 1px solid #ccc;
`;

const StyledBox = styled(Box)`
  background-color: #e5ecf3;
  color: #294666;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 40px;
  font-size: 14px;

  ol{
    list-style-position: inside;
    padding: 0;

    li{
      margin: 2px 0;
    }
  }
`;

const CabinInfo = ({ color, text }) => (
  <Paragraph>
    <StyledCircle is="span" size={30} bg={color} p={0} mr={3} />
    <span>{text}</span>
  </Paragraph>
);
CabinInfo.propTypes = {
  color: PropTypes.string,
  text: PropTypes.string,
};

const SelectCabinInformation = () => (
  <T
    text={[
      AppText.SelectCabinInfoHeading,
      AppText.CabinInstructionList,
      AppText.SelectCabinInfoParagraph,
    ]}
    render={([
      selectCabinInfoHeading,
      cabinInstructionList,
      selectCabinInfoParagraph,
    ]) => (
      <StyledBox>
        <GlowHeading f={3}>{ selectCabinInfoHeading }</GlowHeading>
        <ol>
          {cabinInstructionList.split(';').map(d => <li key={d}>{d}</li>)}
        </ol>
        <span>{ selectCabinInfoParagraph }</span>
      </StyledBox>
    )}
  />
);
export default SelectCabinInformation;



// WEBPACK FOOTER //
// ./src/components/organisms/SelectCabinInformation/index.js